import './css/ResultView.css';

import * as React from 'react';
import { DragDropContext } from 'react-dnd';
import HTML5Backend from 'react-dnd-html5-backend';
import TouchBackend from 'react-dnd-touch-backend';
import MultiBackend, { TouchTransition } from 'react-dnd-multi-backend';
import { detect } from 'detect-browser';
import { connect } from 'react-redux';

import { saveDocument, dragNDropProduct } from '../../../../actions/actions';
import { placeOrder } from '../../../../actions/orderActions';
import { IBranding, ICrop, IDocument, IEditorState, IOrderQuantities_Addresses, IPage, ISpread, IUserData } from '../../../../infrastructure/interfaces';
import ResultAside from './ResultAside';
import ResultContent from './ResultContent';
import ResultHeader from './ResultHeader';
import { productType } from 'src/infrastructure/ProductType';

const browser = detect();

const mapStateToProps = (state: any, ownProps: any) => {
  return {
    type: state.document.type,
    document: state.document,
    brandings: state.wizard.brandings,
    userData: state.user.data,
    editor: state.editor,
    disclaimers: state.wizard.disclaimers,
    dividers: state.wizard.dividers,
  };
};


export interface IResultViewProps {
  document: IDocument;
  crops: ICrop[];
  brandings: IBranding[];
  disclaimers: any[];
  userData: IUserData;
  saveDocument(document: IDocument, userID: string): void;
  placeOrder(document: IDocument, userID: string, user_email: string, username: string, comments: string, orderQuantitiesAddresses: IOrderQuantities_Addresses[]): void;
  editor: IEditorState;
  dividers?: any;
  dragNDropProduct(data: any): void;
}

const mapDispatchToProps = (dispatch: any): any => {
  return {
    saveDocument: (document: IDocument, userID: string) => {
      dispatch(saveDocument(document, userID));
    },
    placeOrder: (document: IDocument, userID: string, user_email: string, username: string, comments: string, orderQuantitiesAddresses: IOrderQuantities_Addresses[]) => {
      dispatch(placeOrder(document, userID, user_email, username, comments, orderQuantitiesAddresses));
    },
    dragNDropProduct: (data: any) => {
      dispatch(dragNDropProduct(data));
    },
  };
};
export interface IResultViewState {
  isSpreadView: boolean;
  selectedPage: IPage;
  selectedSpread: ISpread;
}

// Touch must be on ResultView for side bar drag N drop thumbnails to render,
// even though dragging is disabled in ResultView
const HTML5toTouch = {
  backends: [
    {
      backend: HTML5Backend,
    },
    {
      backend: TouchBackend({
        enableMouseEvents: true,
        ignoreContextMenu: true,
        delayTouchStart: 200,
      }),
      preview: true,
      transition: TouchTransition,
    },
  ],
};

const touchBackend = {
  backend: TouchBackend({
    enableMouseEvents: true,
    ignoreContextMenu: true,
    delayTouchStart: 200,
  }),
};

@DragDropContext(browser && browser.name === 'edge' ? touchBackend.backend : MultiBackend(HTML5toTouch))
@(connect(mapStateToProps, mapDispatchToProps) as any)
export default class ResultView extends React.Component<IResultViewProps, IResultViewState> {

  constructor(props: any) {
    super(props);
    const { editor } = props;
    this.state = {
      isSpreadView: true,
      selectedPage: editor.selectedPage,
      selectedSpread: editor.selectedSpread,
    };
  }


  render() {
    const {
      selectedPage,
      selectedSpread,
    } = this.props.editor;
    const isSpreadView = (this.props.document.type == productType.Brochure) || (this.props.document.type == productType.Poster) || (this.props.document.type == productType.Postcard)

    const sidebarMarkup = ((this.props.document.type !== productType.Bulletin) && (this.props.document.type !== productType.Poster))
    ? (<ResultAside
      isEditorView={false}
      document={null}
      isSpreadView={isSpreadView}
      disclaimers={null} />)
    : [];
    return (
      <div className="result-view">
        <ResultHeader
          isSpreadView={isSpreadView}
          document={this.props.document}
          userData={this.props.userData}
        />
        <div className="result-view-container">
          {sidebarMarkup}
          <div className="product-container product-container--result">
            <ResultContent
              document={this.props.document}
              editor={this.props.editor}
              selectedSpread={selectedSpread}
              selectedPage={selectedPage}
              isSpreadView={isSpreadView}
              disclaimers={this.props.disclaimers}
              dividers={this.props.dividers}
              isEditorEditing={true}
              isWebPageCover={true}
              isPrintDownload={true}
            /> 
          </div>
        </div>
      </div>
    );
  }
}




// WEBPACK FOOTER //
// ./src/components/Editor/components/Result/ResultView.tsx